import DebtGraph from './DebtGraph'

export default DebtGraph
